import React from 'react';
import MediaQuery from 'react-responsive';

/* eslint-disable react/prop-types */
export const withMediaQuery = (Component, componentProps) => (
  componentProps.map((mediaQuery, i) => {
    const { minWidth, maxWidth, ...rest } = mediaQuery;

    return (
      <MediaQuery maxWidth={maxWidth} minWidth={minWidth} key={`media-${i}`}>
        <Component {...rest} />
      </MediaQuery>
    );
  })
);

export const isMobileHOC = (WrappedComponent) => {
  class IsMobile extends React.Component {
    state = {
      isMobile: false,
      activeSlide: null
    }

    componentDidMount = () => {
      this.checkWindowSize();
      window.addEventListener('resize', this.checkWindowSize);
    }

    componentWillUnmount = () => {
      window.removeEventListener('resize', this.checkWindowSize);
    }

    checkWindowSize = () => {
      const windowSize = window.innerWidth;

      if (windowSize <= 480 && !this.state.isMobile) {
        this.setState({ isMobile: true });
      } else if (windowSize > 480 && this.state.isMobile) {
        this.setState({
          isMobile: false,
        });
      }
    }

    render() {
      return <WrappedComponent isMobile={this.state.isMobile} {...this.props} />;
    }
  }
    
  return IsMobile;
};

/* eslint-enable react/prop-types */


// WEBPACK FOOTER //
// ./src/uis/common/utils.js